import _ from 'lodash';
import $ from 'jquery';
import { isDev, getJSONData as _getJSONData, setJSONData as _setJSONData } from '../../utils';
import uuid from 'uuid/v4';
import { strings } from '../../localization/localization';

export const defaultJsonData = {
  base_url: 'http://app.test',
  context: 'global',
  loadedSegmentationId: null,
  operator: 'AND',
  activeFilters: [],
  segmentation_filters: [],
  named_segmentation_context: null,
};

export const operatorsMap = {
  equal_to: { name: strings.Utils.equalTo },
  not_equal_to: { name: strings.Utils.notEqualTo },
  str_contains: { name: strings.Utils.contains },
  str_not_contains: { name: strings.Utils.doesNotContain },
  in: { name: strings.Utils.oneOf },
  not_in: { name: strings.Utils.notOneOf },
  greater_than: { name: strings.Utils.greaterThan },
  less_than: { name: strings.Utils.lessThan },
  greater_than_or_equal_to: { name: strings.Utils.greaterThanOrEqualTo },
  less_than_or_equal_to: { name: strings.Utils.lessThanOrEqualTo },
  boolean_in: { name: strings.Utils.oneOf },
  boolean_not_in: { name: strings.Utils.notOneOf },
  boolean_datetime_in: { name: strings.Utils.oneOf },
  boolean_datetime_not_in: { name: strings.Utils.notOneOf },
  datetime_equal_to: { name: strings.Utils.equalTo },
  datetime_not_equal_to: { name: strings.Utils.notEqualTo },
  datetime_greater_than: { name: strings.Utils.greaterThan },
  datetime_less_than: { name: strings.Utils.lessThan },
  datetime_greater_than_or_equal_to: { name: strings.Utils.greaterThanOrEqualTo },
  datetime_less_than_or_equal_to: { name: strings.Utils.lessThanOrEqualTo },
  years_passed_greater_than: { name: strings.Utils.greaterThan },
  years_passed_less_than: { name: strings.Utils.lessThan },
  years_passed_greater_than_or_equal_to: { name: strings.Utils.greaterThanOrEqualTo },
  years_passed_less_than_or_equal_to: { name: strings.Utils.lessThanOrEqualTo },
  has_any: { name: strings.Utils.hasAnyOf },
  has_all: { name: strings.Utils.hasAllOf },
};

export const makeFilter = (filterType, availableFilters, values = {}) => {
  const filterProto = _.find(availableFilters, { filter: filterType });

  if (!filterProto) return null;

  const filterObj = {
    client_id: uuid(),
    operators: [],
    ...filterProto,
    ..._.pick(values, ['client_id', 'filter', 'sortOrder', 'operator', 'value']),
    optionsDataLoaded: false,
    optionsData: [],
    operator: values.operator && filterProto.operators.includes(values.operator) ?
      values.operator :
      _.get(filterProto.operators, '0')
  };

  return filterObj;
}

export const optionsToSelectOptions = (options) => options.map(option => ({
    label: option.name,
    value: option._id
}));

export const selectedToOptionValue = (selectedOptions) => {
  if (_.isArray(selectedOptions)) {
    // Multi-Select
    return selectedOptions.map(selectedOption => selectedOption.value);
  } else {
    // Single Select
    return _.get(selectedOptions, 'value');
  }
}

export const filterValueToSelectValue = (filterOptions, value, selectType) => {
  if (value === null) {
    return selectType === 'select_multiple' ? [] : '';
  }

  const selectOptions = optionsToSelectOptions(filterOptions);

  if (_.isArray(value)) {
    // Multi-Select
    return selectOptions.filter(selectOption => value.indexOf(selectOption.value) !== -1);
  } else {
    // Single Select
    return _.find(selectOptions, { value });
  }
}

export const getJSONData = () => {
  const defaultData = { ...defaultJsonData };

  if (isDev()) {
    defaultData.base_url = 'http://app.test';
    defaultData.context = 'social_profiles.master_list';
    defaultData.segmentation_filters = ['social_profiles.*'];
    defaultData.named_segmentation_context = null;
  }

  return {
    ...defaultData,
    ..._getJSONData('input[name="segmentation_filter"]'),
  };
}

export const setJSONData = (value) => {
  _setJSONData('input[name="segmentation_filter"]', value);
}

export const submitForm = () => {
  if (isDev()) {
    console.log('Submitted!', document.querySelector('input[name="segmentation_filter"]').value)
  } else {
    const $form = $('input[name="segmentation_filter"]').parents('form');
    $form.submit();
  }
}
